import { Routes, RouterModule }  from '@angular/router';

import { LoginComponent } from './components/login.component';
import { ForgotPasswordComponent } from './components/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { ModuleWithProviders } from '@angular/core';

import { IntroComponent } from '../intro/components/intro.component';
import { ChangePasswordComponent } from '../user/components/change-password.component';
import { HandleLoggedUserGuard } from './services/handle-logged-user-guard.service';


// noinspection TypeScriptValidateTypes
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [HandleLoggedUserGuard]
  },
  {
    path: 'intro',
    component: IntroComponent
  },
  {
    path: 'logout',
    // canActivate: [AuthGuardRouterService]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'resetar-senha/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  }
];

export const routing = RouterModule.forChild(routes);